module.exports = __webpack_public_path__ + "static/img/xdt.d0b3279.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xdt.png
// module id = Mh9+
// module chunks = 0